import { TAppState } from '../../types/appState';

export const userCardIsOpenSelector = (state: TAppState) => state.userCard.isOpen;
